import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';
import type { JoinPathOption } from '../services/measure.service';

interface ListRecordsResponse<T> {
  records: T[];
}

export function useMeasureJoinPathOptions(measureId: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<JoinPathOption[]>({
    queryKey: ['measure-join-path-options', measureId],
    queryFn: async () => {
      const result = await ApiService.getInstance().request(
        'GET',
        `/measures/${measureId}/join_path_options`
      ) as ListRecordsResponse<JoinPathOption>;
      return result.records;
    },
    enabled: enabled && !!measureId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
